// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__1LeBk","link":"Pagination_link__z7Yun"};